/* snoot: Formula Explorer. Orbit style: tabs switch the panel and cycle on their own until a shopper taps one. */
(function () {
  function init(root) {
    if (root.__sfx) return;
    root.__sfx = true;
    var sw = root.querySelector('[data-sfx-swipe]'), bar = root.querySelector('[data-sfx-bar]');
    if (sw && bar) {
      var paint = function () { var max = sw.scrollWidth - sw.clientWidth; var vis = Math.max(0.15, Math.min(1, sw.clientWidth / sw.scrollWidth)); bar.style.width = (vis * 100) + '%'; bar.style.transform = 'translateX(' + (max > 0 ? (sw.scrollLeft / max) * (100 / vis - 100) : 0) + '%)'; };
      sw.addEventListener('scroll', paint, { passive: true }); window.addEventListener('resize', paint); paint();
    }
    var tabs = [].slice.call(root.querySelectorAll('[data-sfx-tab]'));
    var panels = [].slice.call(root.querySelectorAll('[data-sfx-panel]'));
    if (!tabs.length) return;
    var cur = 0, timer = null, seen = false;
    function show(i) {
      cur = i;
      tabs.forEach(function (t, k) { t.classList.toggle('is-on', k === i); t.setAttribute('aria-selected', k === i ? 'true' : 'false'); });
      panels.forEach(function (p, k) { p.hidden = k !== i; });
    }
    function stop() { if (timer) clearInterval(timer); timer = null; }
    tabs.forEach(function (t, k) {
      t.addEventListener('click', function () { stop(); show(k); });
      t.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        var n = (cur + (e.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length;
        stop(); show(n); tabs[n].focus({ preventScroll: true });
      });
    });
    if (root.getAttribute('data-autoplay') === 'true' && 'IntersectionObserver' in window && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
      new IntersectionObserver(function (es) {
        if (es[0].isIntersecting && !timer && !seen) {
          timer = setInterval(function () { show((cur + 1) % tabs.length); }, 3600);
        } else if (!es[0].isIntersecting && timer) { stop(); }
      }, { threshold: 0.4 }).observe(root);
      root.addEventListener('pointerdown', function () { seen = true; stop(); }, { once: true });
    }
    root.addEventListener('shopify:block:select', function (e) {
      var t = e.target.closest('[data-sfx-tab]'); if (t) { stop(); seen = true; show(tabs.indexOf(t)); }
    });
  }
  function boot() { [].forEach.call(document.querySelectorAll('[data-sfx]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
